<template>
  <v-row
    v-if="showReportBar"
    class="mt-0 mb-0"
  >
    <v-col class="py-0">
      <v-sheet
        class="elevation-0"
        style="background: none;"
      >
        <v-slide-group
          v-model="slideFavorites"
        >
          <v-slide-item
            v-for="(favorite, index) in favorites"
            :key="index"
            :slot-scope="index"
            :class="`rounded pa-0 ${ index === 0 ? 'ml-0 mr-2' : 'mx-2' } ${isCurrentlyActiveStandalone(favorite) ? 'darkestblue white--text' : 'white darkestblue--text'}`"
          >
            <v-col class="col-auto">
              <v-btn
                :class="`elevation-0 py-4 ${isCurrentlyActiveStandalone(favorite) ? 'darkestblue white--text' : 'white darkestblue--text'}`"
                x-small
                @click="unfavoriteReportOnRole(favorite)"
              >
                <v-icon
                  small
                >
                  star
                </v-icon>
              </v-btn>

              <v-btn
                :class="`elevation-0 px-2 py-4 ${isCurrentlyActiveStandalone(favorite) ? 'darkestblue white--text' : 'white darkestblue--text'}`"
                @click="toggleReportCriteria(favorite)"
              >
                <span
                  class="justify-center subtitle-2"
                >{{ favorite.reportLabel }}</span>
              </v-btn>

              <v-dialog
                v-model="showModalReportInfo"
                max-width="500"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    :class="`elevation-0 py-4 ${isCurrentlyActiveStandalone(favorite) ? 'darkestblue white--text' : 'white darkestblue--text'}`"
                    x-small
                    @click.stop="toggleModal('ReportInfo', favorite)"
                    v-on="on"
                  >
                    <v-icon
                      small
                    >
                      info
                    </v-icon>
                  </v-btn>
                </template>

                <v-card
                  class="px-0"
                >
                  <v-card-title>
                    <v-row class="px-4 py-2 align-center">
                      <v-col class="px-0">
                        <v-skeleton-loader
                          v-if="!modalData"
                          class="px-0 mt-2"
                          :loading="true"
                          type="text"
                        />

                        <div
                          v-else
                          class="darkblue--text subtitle-2"
                        >
                          {{ modalData.reportLabel }}
                        </div>
                      </v-col>

                      <v-spacer />

                      <v-btn
                        :ripple="false"
                        icon
                        @click.stop="toggleModal('ReportInfo')"
                      >
                        <v-icon color="brightblue">
                          close
                        </v-icon>
                      </v-btn>
                    </v-row>
                  </v-card-title>

                  <v-divider />

                  <v-skeleton-loader
                    v-if="!modalData"
                    class="px-0 mt-2 mx-4"
                    :loading="true"
                    type="text"
                  />

                  <report-info v-else />
                </v-card>
              </v-dialog>
            </v-col>
          </v-slide-item>

          <v-slide-item
            v-if="currentSelectedReport && !currentSelectedReport.isFavorite"
            :slot-scope="favorites.length + 1"
            :class="`rounded pa-0 mx-2 ${isCurrentlyActiveStandalone(currentSelectedReport) ? 'darkestblue white--text' : 'white darkestblue--text'}`"
          >
            <v-col class="col-auto">
              <v-btn
                class="elevation-0 py-4 darkestblue white--text"
                x-small
                @click="favoriteReportOnRole(currentSelectedReport)"
              >
                <v-icon
                  small
                >
                  star_border
                </v-icon>
              </v-btn>

              <v-btn
                class="elevation-0 px-2 py-4 darkestblue white--text"
                @click="toggleReportCriteria(currentSelectedReport)"
              >
                <span
                  class="justify-center text-uppercase subtitle-2"
                >{{ currentSelectedReport.reportLabel }}</span>
              </v-btn>

              <v-dialog
                v-model="showModalReportInfo"
                max-width="500"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    :class="`elevation-0 py-4 ${isCurrentlyActiveStandalone(currentSelectedReport) ? 'darkestblue white--text' : 'white darkestblue--text'}`"
                    x-small
                    @click.stop="toggleModal('ReportInfo', currentSelectedReport)"
                    v-on="on"
                  >
                    <v-icon
                      small
                    >
                      info
                    </v-icon>
                  </v-btn>
                </template>

                <v-card
                  class="pt-4 px-4"
                >
                  <v-card-title>
                    <v-row class="px-3 py-2 align-center">
                      <v-skeleton-loader
                        v-if="!modalData"
                        class="px-0 mt-2"
                        :loading="true"
                        type="text"
                      />

                      <div
                        v-else
                        class="darkblue--text subtitle-2"
                      >
                        {{ modalData.reportLabel }}
                      </div>

                      <v-spacer />

                      <v-btn
                        :ripple="false"
                        icon
                        @click.stop="toggleModal('ReportInfo')"
                      >
                        <v-icon color="brightblue">
                          close
                        </v-icon>
                      </v-btn>
                    </v-row>
                  </v-card-title>

                  <v-divider class="mb-6" />

                  <v-skeleton-loader
                    v-if="!modalData"
                    class="px-0 mt-2"
                    :loading="true"
                    type="text"
                  />

                  <report-info v-else />
                </v-card>
              </v-dialog>
            </v-col>
          </v-slide-item>

          <v-slide-item
            :slot-scope="favorites.length + 2"
            class="pa-0"
          >
            <v-menu
              v-if="notFavorites.length"
              :close-on-click="false"
              offset-y
              open-on-hover
              transition="slide-y-transition"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  class="mx-2"
                  color="secondary"
                  outlined
                  rounded
                  v-on="on"
                >
                  <span
                    class="justify-center text-uppercase subtitle-2"
                  >Other Reports</span>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  v-for="(notFavorite, index) in notFavorites"
                  :key="index"
                  dense
                >
                  <v-col class="col-auto py-0 pr-0">
                    <v-btn
                      icon
                      small
                      @click.stop="favoriteReportOnRole(notFavorite)"
                    >
                      <v-icon
                        small
                      >
                        star_border
                      </v-icon>
                    </v-btn>
                  </v-col>

                  <v-col class="col-grow py-0 pl-0">
                    <v-btn
                      class="px-2"
                      text
                      @click="toggleReportCriteria(notFavorite)"
                    >
                      <span
                        class="justify-center text-uppercase subtitle-2"
                      >{{ notFavorite.reportLabel }}</span>
                    </v-btn>
                  </v-col>

                  <v-col class="col-auto py-0">
                    <v-dialog
                      v-model="showModalReportInfo"
                      max-width="500"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          x-small
                          @click.stop="toggleModal('ReportInfo', notFavorite)"
                          v-on="on"
                        >
                          <v-icon
                            x-small
                          >
                            question_mark
                          </v-icon>
                        </v-btn>
                      </template>

                      <v-card
                        class="pt-4 px-4"
                      >
                        <v-card-title>
                          <v-row class="px-3 py-2 align-center">
                            <v-skeleton-loader
                              v-if="!modalData"
                              class="px-0 mt-2"
                              :loading="true"
                              type="text"
                            />

                            <div
                              v-else
                              class="darkblue--text subtitle-2"
                            >
                              {{ modalData.reportLabel }}
                            </div>

                            <v-spacer />

                            <v-btn
                              :ripple="false"
                              icon
                              @click.stop="toggleModal('ReportInfo')"
                            >
                              <v-icon color="brightblue">
                                close
                              </v-icon>
                            </v-btn>
                          </v-row>
                        </v-card-title>

                        <v-divider class="mb-6" />

                        <v-skeleton-loader
                          v-if="!modalData"
                          class="px-0 mt-2"
                          :loading="true"
                          type="text"
                        />

                        <report-info v-else />
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-list-item>

                <v-list-item
                  dense
                >
                  <v-col
                    class="col-auto pr-0"
                  >
                    <v-btn
                      icon
                      small
                    >
                      <v-icon
                        small
                      >
                        add
                      </v-icon>
                    </v-btn>
                  </v-col>

                  <v-col class="col-grow py-0 pl-0">
                    <v-btn
                      class="px-2"
                      text
                      @click="createNewReport"
                    >
                      <span
                        class="justify-center text-uppercase subtitle-2"
                      >New Report</span>
                    </v-btn>
                  </v-col>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-slide-item>
        </v-slide-group>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapState: mapReportState } = createNamespacedHelpers('report')
const { mapState: mapLayoutState } = createNamespacedHelpers('layout')
const { mapGetters: mapToolsGetters } = createNamespacedHelpers('tools')

export default {
  name: 'ReportBar',
  components: {
    ReportInfo: () => import('src/report/components/ReportInfo'),
  },
  props: {
    favorites: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      slideFavorites: [],
    }
  },
  computed: {
    ...mapLayoutState({
      $isLayoutFullScreen: (state) => state.isLayoutFullScreen,
    }),
    ...mapReportState({
      $modalData: (state) => state.modalData,
      $selectedReport: (state) => state.selectedReport,
      $showModalReportInfo: (state) => state.showModalReportInfo,
    }),
    ...mapToolsGetters([
      'currentMetric',
      'currentSelectedReport',
      'notFavorites',
    ]),
    showReportBar() {
      return !this.$isLayoutFullScreen
    },

    query() {
      return this.$route.query
    },

    modalData() {
      return this.$modalData
    },
    showModalReportInfo: {
      get() {
        return this.$showModalReportInfo
      },
      set(value) {
        this.$store.commit('report/showModalReportInfo', value)
      },
    },
  },
  methods: {
    isCurrentlyActiveStandalone(report) {
      const { currentSelectedReport } = this
      const { docId, reportPath } = currentSelectedReport || {}
      return currentSelectedReport && (reportPath === report.reportPath || docId === report.docId)
    },
    toggleReportCriteria(favoriteReport) {
      const { currentSelectedReport } = this
      if (currentSelectedReport && currentSelectedReport.docId === favoriteReport.docId) {
        this.$router.replace({
          params: this.$route.params,
          query: {
            ...this.query,
            reportPath: 'all-data',
          },
        })
      } else {
        this.$router.replace({
          params: this.$route.params,
          query: {
            ...this.query,
            reportPath: favoriteReport.reportPath,
          },
        })
      }
    },
    favoriteReport(report) {
      this.$store.dispatch('report/favoriteReport', report)
    },
    unfavoriteReport(report) {
      this.$store.dispatch('report/unfavoriteReport', report)
    },
    favoriteReportOnRole(report) {
      this.$store.dispatch('report/favoriteReportOnRole', report)
    },
    unfavoriteReportOnRole(report) {
      this.$store.dispatch('report/unfavoriteReportOnRole', report)
    },
    toggleModal(modalName, modalData) {
      const storeName = 'report'
      this.$store.dispatch('tools/toggleModal', { modalData, modalName, storeName })
    },
    createNewReport() {
      this.$router.replace({
        params: this.$route.params,
        query: {
          ...this.query,
          action: 'create',
          reportPath: null,
        },
      })
    },
  },
}
</script>
